export type FrontendErrorSeverity =
  | "error"
  | "warn"
  | "network"
  | "runtime"
  | "react"
  | "swr"
  | "console";

export interface FrontendErrorLog {
  id: number;
  created_at: string;
  message: string;
  severity: FrontendErrorSeverity;
  route?: string;
  stack?: string;
  component_name?: string;
  user_id?: string;
  version?: string;
  metadata?: Record<string, unknown>;
}

export interface FrontendErrorDigestSummary {
  windowStart?: string;
  windowEnd?: string;
  total: number;
  uniqueUsers: number;
  errorsByHour: Array<{ hour: string; count: number }>;
  severity: Record<string, number>;
  routes: Array<{ route: string; count: number }>;
  versions: Array<{ version: string; count: number }>;
  fingerprints: Array<{ fingerprint: string; message: string; count: number; recurring: boolean }>;
  newVsRecurring: { new: number; recurring: number };
}

export interface FrontendErrorDigest {
  digest_date: string;
  total_errors: number;
  unique_users: number;
  summary: FrontendErrorDigestSummary;
  html_body: string;
  recipients?: string[];
}

export interface FrontendUserSummary {
  top_users: Array<{ user_id: string; error_count: number; last_seen: string | null }>;
  average_crashes_per_user: number;
  high_risk_users: string[];
  routes_by_user: Record<string, Record<string, number>>;
}

export interface FrontendHeatmap {
  routes: string[];
  hours: string[];
  matrix: number[][];
}

export const severityOptions: { value: FrontendErrorSeverity | "all"; label: string }[] = [
  { value: "all", label: "All severities" },
  { value: "runtime", label: "Runtime" },
  { value: "react", label: "React" },
  { value: "network", label: "Network" },
  { value: "swr", label: "SWR" },
  { value: "console", label: "Console" },
  { value: "error", label: "Error" },
  { value: "warn", label: "Warn" },
];

export const severityStyles: Record<FrontendErrorSeverity, string> = {
  error: "border-rose-500/70 bg-rose-500/15 text-rose-200",
  warn: "border-amber-500/70 bg-amber-500/15 text-primary-foreground dark:text-amber-200",
  network: "border-sky-500/70 bg-sky-500/15 text-sky-200",
  runtime: "border-orange-500/70 bg-orange-500/15 text-orange-200",
  react: "border-violet-500/70 bg-violet-500/15 text-violet-200",
  swr: "border-emerald-500/70 bg-emerald-500/15 text-emerald-200",
  console: "border-border/70 bg-muted/40 text-foreground/80",
};
